import api from './api';

export const getClinic = async () =>
    api
        .request({
            method: 'GET',
            url: '/clinics'
        })
        .catch(res => res);
